export default __webpack_public_path__ + "462d450599f14e2c0a2b5be97292a48f.png";